import {
  ReactNode,
  createContext,
  useContext,
  useEffect,
  useState,
} from 'react'

interface LocaleInterface {
  currency?: string
  metric?: boolean
}

const LocaleContext = createContext<LocaleInterface>({
  currency: 'USD',
  metric: false,
})

const LocaleProvider = ({
  children,
  currency: initialCurrency = 'USD',
  metric: initialMetric = false,
}: {
  children: ReactNode
  currency?: string
  metric?: boolean
}) => {
  // Allow dynamic updates of currency and metric
  const [currency, setCurrency] = useState(initialCurrency)
  const [metric, setMetric] = useState(initialMetric)

  useEffect(() => {
    setCurrency(initialCurrency)
  }, [initialCurrency])

  useEffect(() => {
    setMetric(initialMetric)
  }, [initialMetric])

  const value = {
    currency,
    metric,
  }

  return (
    <LocaleContext.Provider value={value}>{children}</LocaleContext.Provider>
  )
}

const useLocale = () => useContext(LocaleContext)

export { useLocale, LocaleProvider, LocaleContext }
